import { NestedRoutes } from "../../app/routes.types";
import { DashboardLayout } from "./layout";
import { Dashboard } from "./index";
import { EmployeeDetail } from "./EmployeeDetail";
import { UserPermissions } from "../../enums";
import { TeamsDashboard } from "./teamDetails";

export const dashboardRoutes: NestedRoutes = {
  name: "Dashboard",
  path: "dashboard",
  layout: DashboardLayout,
  defaultPath: "",
  component: Dashboard,
  permissions: [
    UserPermissions.DashboardView,
    UserPermissions.DashboardViewLead,
  ],
  children: [
    {
      name: "Employee Detail",
      path: ":memberId/employeeDetail",
      component: EmployeeDetail,
      permissions: [UserPermissions.DashboardViewMemberDetails],
    },
    {
      name: "Teams Detail",
      path: ":teamLeadId/team",
      component: TeamsDashboard,
      permissions: [UserPermissions.DashboardViewLead],
    },
  ],
};
